import React from 'react';
import { bool, node } from 'prop-types';
import classnames from 'classnames/bind';

import styles from './ActionMenu.css';

const cx = classnames.bind(styles);

const ActionMenu = ({ children, statusPage, landing, withSeparator }) => (
  <div
    className={cx(
      styles.actionMenu,
      {
        statusPage: statusPage,
        landing: landing,
        withSeparator: withSeparator
      }
    )}
  >
    {children}
  </div>
);

ActionMenu.propTypes = {
  children: node.isRequired,
  statusPage: bool,
  landing: bool,
  withSeparator: bool
};

ActionMenu.displayName = 'ActionMenu';

export default ActionMenu;


// WEBPACK FOOTER //
// ./src/uis/components/Header/ActionMenu/ActionMenu.js